import useAuth from "src/hooks/useAuth";
import { useMS } from "../context/MSContext";
import { useState } from "react";
import { deleteItemFromOneDrive, getFileContentAsBase64 } from "src/graph";
import axios from "src/axios/axios";
import toast from "react-hot-toast";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "src/components/ui/alert-dialog";
import { Button } from "src/components/ui/button";
import { CloudUploadIcon } from "lucide-react";

type UTF = {
    selected_documents: string[]
    onedrivedocuments:any[]
    onSuccess?: () => void;
    trigger?: React.ReactNode
}

export const UploadToFitdoc = ({selected_documents, onedrivedocuments, trigger, onSuccess}:UTF) => {
    const { auth } = useAuth()
    const { accessToken } = useMS()
    const [removeFromDrive, setremoveFromDrive] = useState(true);

    async function handleUpdateDocuments () {
        try {
            toast.loading('Documenten uploaden in FITdoc...', { id:'updateDocuments' });

            const updatePromises = selected_documents.map(async (id) => {
                const fileOneDrive = onedrivedocuments.find(d => d.id === id);
                const fileNameOneDrive = fileOneDrive?.name || '';
                const docid = fileNameOneDrive.match(/\[(.*?)\]/)[1];
                const startIndex = fileNameOneDrive.indexOf('] - ') + 4; // +4 to include the ' - ' part
                const fileName = fileNameOneDrive.substring(startIndex);
                const base64String = await getFileContentAsBase64(accessToken, fileOneDrive.id);

                const response = await axios.post(`documents/addversion`, {
                    token: auth.data?.token,
                    filename: fileName,
                    file: base64String,
                    docid: docid
                });

                if (response.data.errorcode !== 0) {
                    throw new Error(`user ${id} updating failed`);
                }

                // Optionally remove from OneDrive if specified
                if (removeFromDrive) {
                    await deleteItemFromOneDrive(accessToken, fileOneDrive.id);
                }
            });

            await Promise.all(updatePromises);

            onSuccess && onSuccess();
            toast.remove('updateDocuments');
        } catch (error) {
            console.log(error);
            toast.error('Document updaten in FitDoc mislukt', { id:'updateDocuments' })
        }
    }

    return (
        <AlertDialog>
            <AlertDialogTrigger asChild>
                {trigger ? trigger : 
                <Button disabled={selected_documents.length === 0} className='gap-2'><CloudUploadIcon className='w-4 h-4 group-hover:text-primary'/>Uploaden in FitDoc</Button>
                }
            </AlertDialogTrigger>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>Let op! Documenten uploaden naar FitDoc</AlertDialogTitle>
                    <AlertDialogDescription>U staat op het punt om {selected_documents.length} document{selected_documents.length > 1 && 'en'} te overschrijven</AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel>Annuleren</AlertDialogCancel>
                    <AlertDialogAction onClick={()=>{handleUpdateDocuments()}}>Uploaden</AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    )
}